import { render } from "./Home.vue?vue&type=template&id=65b4e20e"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=65b4e20e&lang=scss"

import exportComponent from "/Users/jeromebart/sites/cdm-quiz/cite-des-metiers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__